module.exports = __webpack_public_path__ + "img/_invisible_contact.513397d2.svg";